import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-drawn-line-width",
  "use": "icon-drawn-line-width-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-drawn-line-width\"><g transform=\"translate(5 12)\"><path d=\"M9 4c0 .711.149 1.388.416 2H2a2 2 0 1 1 0-4l7.417-.001A4.983 4.983 0 0 0 9 4Zm11-2a2 2 0 1 1 0 4h-1.416A4.992 4.992 0 0 0 19 4c0-.712-.149-1.389-.417-2.001L20 2Z\" /><circle cx=\"14\" cy=\"4\" r=\"4\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol